import type {
  IDemo,
  IVariable,
  Opportunity,
  PlaySource,
} from '@carboncopyco/types';
import constate from 'constate';
import { type ReactNode, useState } from 'react';

export type SubmissionValues = {
  forClient: string;
  opportunity?: Opportunity | null;
  variables: Record<IDemo['id'], IVariable[]>;
  speakerNotes: Record<IDemo['id'], string>;
};

type GiveADemoContext = {
  filesServiceUrl: string;
  speakerNotes: Record<string, string>;
  children: ReactNode;
  playSource: PlaySource;
};

const useGiveADemoContext = ({
  filesServiceUrl,
  speakerNotes,
  playSource,
}: GiveADemoContext) => {
  const [submissionValues, setSubmissionValues] = useState<SubmissionValues>({
    forClient: '',
    opportunity: null,
    variables: {},
    speakerNotes,
  });

  return {
    filesServiceUrl,
    submissionValues,
    setSubmissionValues,
    playSource,
  };
};

export const [GiveADemoContextProvider, useGiveADemo] =
  constate(useGiveADemoContext);
